import { useLocation } from 'react-router-dom';

export const useElectricPage = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    return currentPath.startsWith('/electric');
};